import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CheckCircle2, Loader2, Users } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ASSETS } from "@/lib/assets";

export default function AcceptInvite() {
  const { token } = useParams();
  const { user } = useAuth();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const accepting = useRef(false);

  useEffect(() => {
    api.get(`/invites/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e)));
  }, [token]);

  useEffect(() => {
    if (!user || accepting.current || error) return;
    accepting.current = true;
    api.post(`/invites/${token}/accept`)
      .then(({ data }) => { toast.success("Você agora tem acesso à página"); nav(`/editor/${data.project_id}`, { replace: true }); })
      .catch((e) => { setError(errMsg(e)); accepting.current = false; });
  }, [user, token, nav, error]);

  return (
    <div className="min-h-screen bg-[var(--bg)] grid place-items-center p-6" data-testid="accept-invite-page">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white shadow-xl p-8 text-center">
        <Link to="/"><img src={ASSETS.logo} alt="Lowpages" className="h-7 mx-auto" /></Link>
        <div className="mx-auto mt-6 h-14 w-14 grid place-items-center rounded-2xl bg-[var(--blue)]/10 text-[var(--blue)]"><Users size={26} /></div>
        {error ? (
          <>
            <h1 className="font-display font-bold text-2xl mt-5">Convite indisponível</h1>
            <p className="text-slate-500 mt-2 text-sm">{error}</p>
            <Link to="/app" className="btn btn-ink mt-6 inline-flex">Ir para o painel</Link>
          </>
        ) : info === null ? (
          <div className="py-8"><Loader2 className="animate-spin text-slate-300 mx-auto" /></div>
        ) : user ? (
          <>
            <h1 className="font-display font-bold text-2xl mt-5">Entrando na equipe…</h1>
            <p className="text-slate-500 mt-2 text-sm">Preparando <strong>{info.project_name}</strong></p>
            <Loader2 className="animate-spin text-slate-300 mx-auto mt-6" />
          </>
        ) : user === false ? (
          <>
            <h1 className="font-display font-bold text-2xl mt-5">Você foi convidado</h1>
            <p className="text-slate-500 mt-2 text-sm"><strong>{info.invited_by || "Alguém"}</strong> quer editar <strong>{info.project_name}</strong> com você. Entre ou crie sua conta para aceitar.</p>
            <div className="mt-6 flex flex-col gap-3">
              <button data-testid="invite-login" onClick={() => nav("/login", { state: { from: `/invite/${token}` } })} className="btn btn-primary justify-center">Entrar e aceitar</button>
              <button data-testid="invite-register" onClick={() => nav("/register", { state: { from: `/invite/${token}` } })} className="btn btn-ghost justify-center">Criar conta grátis</button>
            </div>
          </>
        ) : (
          <div className="py-8 flex items-center justify-center gap-2 text-emerald-600"><CheckCircle2 /> Pronto</div>
        )}
      </div>
    </div>
  );
}
